import React from "react";
import PackageIcon from "mdi-material-ui/Package";
import { registerOperatorRoute } from "../../../routes";
import ContentViewExtraWideLayout from "../../../layouts/ContentViewExtraWideLayout";
import InventoryMonitoring from "./monitoring/InventoryMonitoring";
import InventoryDiagnosticsPage from "./components/InventoryDiagnosticsPage";

registerOperatorRoute({
  isNavigationLink: true,
  isSetting: false,
  priority: 21,
  layoutComponent: ContentViewExtraWideLayout,
  mainComponent: InventoryDiagnosticsPage,
  path: "/inventory-diagnostics",
  specialAccessId: "inventory-diagnostics",
  // eslint-disable-next-line react/display-name
  SidebarIconComponent: (props) => <PackageIcon {...props} />,
  sidebarI18nLabel: "Inventory Diagnose"
});

registerOperatorRoute({
  isNavigationLink: true, isSetting: false, priority: 20,
  layoutComponent: ContentViewExtraWideLayout, mainComponent: InventoryMonitoring,
  path: "/inventory-monitoring", specialAccessId: "inventory-diagnostics",
  // eslint-disable-next-line react/display-name
  SidebarIconComponent: (props) => <PackageIcon {...props} />,
  sidebarI18nLabel: "Inventar-Monitoring"
});
